// Faint, breathing "light pools" and a gobo dot pattern that live across every
// page — visually a continuation of the moving-head beams from the hero.
export default function Gobos() {
  return (
    <div className="vs-gobos pointer-events-none fixed inset-0 overflow-hidden" aria-hidden>
      <div className="vs-spot vs-spot-1" />
      <div className="vs-spot vs-spot-2" />
      <div className="vs-spot vs-spot-3" />
      <div className="vs-spot vs-spot-4" />
      <div className="vs-gobo-pattern" />
    </div>
  );
}
